<template>
  <div class="sign-in-dialog_wrapper">
    <button @click="$emit('close')" class="sign-in-dialog_close-button">
      <i class="material-icons">close</i>
    </button>
    <div v-if="isSignIn">
      <div class="sign-in-dialog_title">Вход</div>
      <div class="social-title">Зайти через соцсети</div>
      <SocialAuth @success="$emit('success')" />
      <div class="diviner">
        <span>или</span>
      </div>
      <SignInForm class="form" @success="$emit('success')" />
    </div>
    <div v-else>
      <div>
        <div class="sign-in-dialog_title">Регистрация</div>
      </div>
      <SignUpForm class="form" @success="$emit('success')" />
    </div>
    <div class="bottom" v-if="isSignIn">
      <button @click="isSignIn = false">Зарегистироваться</button>
      <div class="hor-div"></div>
      <button>Забыли пароль?</button>
    </div>
    <div class="bottom flex-center" v-else>
      <button @click="isSignIn = true">Войти</button>
    </div>
  </div>
</template>

<script>
import SignInForm from '../forms/signin';
import SignUpForm from '../forms/signup';
import SocialAuth from '../forms/social-signin';

export default {
  components: {
    SignInForm, SignUpForm, SocialAuth
  },
  data: () => ({
    isSignIn: true,
  }),
};
</script>

<style scoped>
.sign-in-dialog_wrapper {
  padding: 0 2rem;
  position: relative;
}
.sign-in_button {
  background-color: rgb(52, 174, 196);
  text-align: center;
  color: #fff;
  width: 100%;
  line-height: 36px;
  border-radius: 4px;
  font-weight: 600;
}
.sign-in_button:disabled {
  opacity: 0.3;
}
.bottom {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  padding: 1rem;
  padding-top: 0;
}
.bottom.flex-center {
  justify-content: center;
}
.bottom button {
  background-color: transparent;
  color: rgb(160, 160, 160);
  transition: color 300ms ease;
  outline: 0;
}
.bottom button:hover {
  color: rgb(77, 75, 75);
}
.bottom .hor-div {
  width: 1px;
  height: 21px;
  background-color: rgb(221, 221, 221);
}
.sign-in-dialog_close-button {
  position: absolute;
  top: 0;
  right: 0;
  background-color: transparent;
  padding: 0.2rem;
  outline: 0;
  color: rgb(196, 196, 196);
  transition: color 300ms ease;
}
.sign-in-dialog_close-button:hover {
  color: rgb(70, 70, 70);
}
.social-title {
  font-weight: 300;
  color: #969696;
  text-align: center;
  font-size: 14px;
}
.form {
  padding: 1rem;
}
.sign-in-dialog_title {
  width: 300px;
  font-weight: 600;
  text-align: center;
  padding-top: 0.5rem;
  font-size: 1.5rem;
  color: #424242;
}
.diviner {
  position: relative;
  height: 1px;
  width: 100%;
  border-top: 1px solid rgb(219, 219, 219);
  margin: 1rem 0;
}
.diviner span {
  position: absolute;
  background-color: #fff;
  left: 0;
  right: 0;
  top: -10px;
  margin: auto;
  width: 50px;
  line-height: 1;
  text-align: center;
  color: #969696;
  font-weight: 300;
}
</style>